import React from 'react';
import formatPrice from '../../services/utils/formatPrice';
import { BiCalendar } from 'react-icons/bi';
import { MdAttachMoney } from 'react-icons/md';
import { setSelectedInstallments } from '../../store/contract/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  IconAlert,
  NotPayment,
  InstallmentCards,
  SelectContainer,
} from './styles';

interface InvoiceListProps {
  contracts: GQL.IContractDetails[];
}

const InvoiceList = ({ contracts }: InvoiceListProps) => {
  const dispatch = useDispatch();

  const { selectedInstallments } = useSelector((state: ApplicationState) => ({
    selectedInstallments: state.contract.selectedInstallments,
  }));

  const handleSelectedInstallment = (installmentId: string) => {
    let newSelected: string[];

    if (selectedInstallments.includes(installmentId)) {
      newSelected = selectedInstallments.filter((id) => id !== installmentId);
    } else {
      newSelected = [...selectedInstallments, installmentId];
    }

    dispatch(setSelectedInstallments(newSelected));
  };

  const handleNoPayment = () => (
    <NotPayment>
      <IconAlert className='alert-icon' />
      <div className='box-notpayment'>
        <p className='title1'>Não possuímos nenhuma fatura para esse débito!</p>
        <span className='title2'>
          Entre em contato nos canais abaixo para mais detalhes.
        </span>
      </div>
    </NotPayment>
  );

  return (
    <>
      {!!contracts?.length ? (
        <>
          {contracts?.map((contract) =>
            !!contract.originalContractInstallments?.length
              ? contract.originalContractInstallments.map((installment) => (
                  <InstallmentCards
                    key={installment.installmentId}
                    onClick={() =>
                      handleSelectedInstallment(
                        installment.installmentId as string
                      )
                    }
                  >
                    <div className='item'>
                      <p className='value'>
                        R$ {formatPrice(Number(installment.mainValue))}
                      </p>
                      <p className='date'>
                        <BiCalendar
                          style={{ marginRight: 4, marginTop: 2.5 }}
                        />
                        <span>
                          Vencimento:{' '}
                          <strong>{installment.formattedDueDate}</strong>
                        </span>
                      </p>
                      <p className='originalValue'>
                        <MdAttachMoney
                          style={{
                            marginRight: 3,
                            marginTop: 1,
                            marginLeft: -1,
                          }}
                          size={17}
                        />
                        <span>
                          Valor Original:{' '}
                          <strong>
                            R$ {formatPrice(Number(installment.originalValue))}
                          </strong>
                        </span>
                      </p>
                    </div>
                    <SelectContainer
                      selected={selectedInstallments.includes(
                        installment.installmentId as string
                      )}
                    >
                      <span />
                    </SelectContainer>{' '}
                  </InstallmentCards>
                ))
              : handleNoPayment()
          )}
        </>
      ) : (
        handleNoPayment()
      )}
    </>
  );
};

export default InvoiceList;
